"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
function mention(id, text) {
    return new Mention(id, text);
}
exports.mention = mention;
class Mention extends index_1.InlineNode {
    constructor(id, text) {
        super();
        this.id = id;
        this.text = text;
    }
    toJSON() {
        return {
            type: 'mention',
            attrs: {
                id: this.id,
                text: this.text
            }
        };
    }
}
exports.Mention = Mention;
//# sourceMappingURL=mention.js.map